import { createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import cartReducer from "./reducers/cartReducer";
import productReducer from "./reducers/productReducer";
import checkReducer from "./reducers/checkReducer";
import authReducer from "./reducers/authReducer";
import deliveryReducer from "./reducers/deliveryReducer";
import adsReducer from "./reducers/adsReducer";
import footerReducer from "./reducers/footerReducer";
import aboutReducer from "./reducers/aboutAction";

const persistConfig = {
  key: "root",
  storage,

  whitelist: ["cart", "auth", "deli", "checkout", "ads", "footer", "about"],
  version: 2,
  migrate: (state) => {
    if (state && Array.isArray(state.cart)) {
      return Promise.resolve({
        ...state,
        cart: {
          cartItems: state.cart,
        },
      });
    }
    return Promise.resolve(state);
  },
};

const rootReducer = combineReducers({
  cart: cartReducer,
  product: productReducer,
  checkout: checkReducer,
  auth: authReducer,
  deli: deliveryReducer,
  ads: adsReducer,
  footer: footerReducer,
  about: aboutReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { store, persistor };
